import { ref } from "vue";
import { defineStore, acceptHMRUpdate } from "pinia";
import type { TUser } from "@/api/user";

export const useAuthStore = defineStore(
  "auth",
  () => {
    const accessToken = ref<string | null>(null);
    const refreshToken = ref<string | null>(null);
    const userInfo = ref<TUser | null>(null);

    function setAuthTokens(setAccessToken: string | null, setRefreshToken?: string | null) {
      accessToken.value = setAccessToken;
      if (setRefreshToken !== undefined) {
        refreshToken.value = setRefreshToken;
      }
    }

    function setUserInfo(setUserInfo: TUser | null) {
      userInfo.value = setUserInfo;
    }

    return { accessToken, refreshToken, userInfo, setAuthTokens, setUserInfo };
  },
  {
    persist: true,
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
